var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('i',{class:_vm.isSelected(),on:{"click":function($event){_vm.setFilter()}}})]),_c('td',[_c('div',{staticClass:"font-input"},[_vm._v(_vm._s(_vm.item.type))])])])}
var staticRenderFns = []

export { render, staticRenderFns }